import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSupportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			rx: 15,
			fill: "url(#paint0_linear_39611_1505)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.1934 21.1212C31.2317 20.152 31.8554 18.2135 34.0433 18.2135C36.7781 18.2135 36.9835 20.6104 37.0084 21.1212C37.0084 23.0473 34.0248 23.2129 34.168 25.0505V25.4962",
			stroke: "white",
			strokeWidth: 2.58,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.0413 28.5768V28.9682",
			stroke: "white",
			strokeWidth: 2.58,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.8601 32.499C43.5031 32.3461 44.8839 31.1443 45.1114 29.51C45.3718 27.6399 45.5165 25.7172 45.5165 23.7381C45.5165 21.6891 45.3717 19.673 45.093 17.7427C44.8726 16.216 43.6264 15.0637 42.0924 14.9025C39.5008 14.6303 36.7932 14.4836 34.0243 14.4836C31.2639 14.4836 28.6042 14.6392 26.0103 14.9074C24.4501 15.0687 23.1829 16.245 22.9614 17.7978C22.6882 19.7131 22.5321 21.7069 22.5321 23.7381C22.5321 25.7533 22.7028 27.7125 22.9713 29.6147C23.1947 31.1971 24.4821 32.4049 26.0721 32.5664C28.6409 32.8273 31.2892 32.9927 34.0243 32.9927C34.0897 32.9927 34.1552 32.9925 34.2206 32.9922C36.1492 35.2108 37.6279 36.3072 40.2124 37.4679V32.6516C40.6314 32.6137 41.0481 32.5748 41.4622 32.5361C41.595 32.5237 41.7277 32.5113 41.8601 32.499Z",
			stroke: "white",
			strokeWidth: 2.58,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9073 22.9505C16.3731 23.1116 15.127 24.264 14.9067 25.7906C14.6278 27.7209 14.4832 29.7371 14.4832 31.7861C14.4832 33.7652 14.6278 35.6878 14.888 37.558C15.1155 39.1922 16.4965 40.3941 18.1396 40.5469C18.2718 40.5593 18.4045 40.5717 18.5375 40.5841C18.9514 40.6228 19.3682 40.6617 19.7872 40.6997V45.516C22.3717 44.3551 23.8504 43.2587 25.779 41.0401C25.8444 41.0406 25.9098 41.0406 25.9753 41.0406C28.7104 41.0406 31.3587 40.8751 33.9275 40.6145",
			stroke: "white",
			strokeWidth: 2.58,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_39611_1505",
			x1: 30,
			y1: 0,
			x2: 30,
			y2: 60,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C3AED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A855F7"
			})]
		}) })
	]
});
export default SvgAiSupportIcon;
